import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import GroupLessonProgram from "./GroupLessonProgram";

class GroupLessonProgramList extends React.Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-xs-3">
            <b>Lesson Programs</b>
          </div>
          <div className="col-xs-9">
            <div className="pull-right">
              {this.props.currentUser.superadmin ? (
                <a className="btn btn-text" href="/group_lesson_programs/new">
                  ADD LESSON PROGRAM
                </a>
              ) : (
                <span data-tip="Only super admins have the ability to add lesson programs">
                  <a className="btn btn-text disabled">ADD LESSON PROGRAM</a>
                  <ReactTooltip />
                </span>
              )}
              {(this.props.currentUser.superadmin && this.props.showStarfishProgram) ? (
                <a className="btn btn-text" href="/group_lesson_programs/duplicate_templates?account_type=starfish">
                  ADD STARFISH PROGRAMS
                </a>
              ) : (
                ""
              )}
              {(this.props.currentUser.superadmin && this.props.showPadiProgram) ? (
                <a className="btn btn-text" href="/group_lesson_programs/duplicate_templates?account_type=padi">
                  ADD PADI PROGRAMS
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        {this.props.groupLessonPrograms.map((groupLessonProgram, index) => (
          <GroupLessonProgram
            key={index}
            groupLessonProgram={groupLessonProgram}
            groupLessonLevels={groupLessonProgram.active_group_lesson_levels}
            currentUser={this.props.currentUser}
          />
        ))}
      </div>
    );
  }
}

GroupLessonProgramList.propTypes = {
  groupLessonPrograms: PropTypes.array
};

export default GroupLessonProgramList;
